import { Route } from '@angular/router';
import { UserDto } from '../models/user/user-dto';
import { isRoleGuard } from './role-guard';

/**
 * Whether the user passes the role guards of a route, so navigation can hide
 * links the guards would reject. Only guards created with `createRoleGuard`
 * count; other guards (e.g. `authGuard`) are not run.
 */
export function canAccessRoute(user: UserDto | null, route: Route): boolean {
  return [...(route.canActivate ?? []), ...(route.canActivateChild ?? [])]
    .filter(isRoleGuard)
    .every(guard => guard.hasRole(user));
}
